import React,{useEffect } from 'react'
import clsx from 'clsx'
import { Link, useParams, useLocation } from 'react-router-dom'

import { toAbsoluteUrl } from '../../../helpers/CommonFunction';
import { useLayout } from '../../core/LayoutProvider';
import SAISVG from '../../../helpers/CommonFunction';

import PageTitle from '../toolbar/page-title/PageTitle';
import Navbar from './Navbar';

const SystemAdminHeader = () => {
    const location = useLocation(); 
    const { company } = useParams();
    useEffect(() => {
        document.body.setAttribute('data-sai-app-header-fixed', 'flase')
    }, [])

    const { config, classes } = useLayout()
    if (!config.app?.header?.display) {
        return null
    }
    const lastSegment = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
    const isShowLogo = !!company || lastSegment === 'received-request';
    return (
        <>
            <div id='sai_app_header' className='app-header'>
                <div
                    id='sai_app_header_container'
                    className={clsx(
                        'app-container flex-lg-grow-1',
                        classes.headerContainer.join(' '),
                        config.app?.header?.default?.containerClass
                    )}
                >
                    {config.app.sidebar?.display && (
                        <>
                            <div
                                className='d-flex align-items-center d-lg-none ms-n2 me-2'
                                title='Show sidebar menu'
                            >
                                <div
                                    className='btn btn-icon btn-active-color-primary w-35px h-35px'
                                    id='sai_app_sidebar_mobile_toggle'
                                >
                                    <SAISVG path='media/icons/duotune/abstract/abs015.svg' className=' svg-icon-1' />
                                </div>
                                <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                                    <Link to='/system-admin/dashboard' className='d-lg-none'>
                                        <img alt='Logo' src='./assets/media/logos/default-small.svg' className='h-30px' />
                                    </Link>
                                </div>
                            </div>
                        </>
                    )}

                    {!isShowLogo && (
                        <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
                            <Link to='/system-admin/dashboard'>
                                {config.layoutType !== 'dark-header' ? (
                                    <>
                                        <img
                                            alt='Logo'
                                            src={toAbsoluteUrl('truvoice_logo-new.png')}
                                            className='h-20px h-lg-30px app-sidebar-logo-default'
                                        />
                                    </>
                                ) : (
                                    <>
                                        <img
                                            alt='Logo'
                                            src={toAbsoluteUrl('truvoice_logo-new.png')}
                                            className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                                        />
                                        <img
                                            alt='Logo'
                                            src={toAbsoluteUrl('truvoice_logo-new.png')}
                                            className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                                        />
                                    </>
                                )}
                            </Link>
                        </div>
                    )}

                    <div
                        id='sai_app_header_wrapper'
                        className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
                    >
                        {config.app.header.default?.content === 'menu' &&
                            config.app.header.default.menu?.display && (
                                <div
                                    className='app-header-menu app-header-mobile-drawer align-items-stretch'
                                    data-sai-drawer='true'
                                    data-sai-drawer-name='app-header-menu'
                                    data-sai-drawer-activate='{default: true, lg: false}'
                                    data-sai-drawer-overlay='true'
                                    data-sai-drawer-width='225px'
                                    data-sai-drawer-direction='end'
                                    data-sai-drawer-toggle='#sai_app_header_menu_toggle'
                                    data-sai-swapper='true'
                                    data-sai-swapper-mode="{default: 'append', lg: 'prepend'}"
                                    data-sai-swapper-parent="{default: '#sai_app_body', lg: '#sai_app_header_wrapper'}"
                                >
                                    <PageTitle />
                                </div>
                            )}
                        <Navbar />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SystemAdminHeader